import { Card, styled, Button } from "@mui/material";

export const ContactPage = styled("div")(({theme,dark}) => ({
  width: "100vw",
  height: "calc(100vh + 150px )",
  backgroundColor: dark? "#1C2028" :"#fff",
  //   backgroundColor: "red",
  maxHeight: "calc(100vh + 150px)",
  maxWidth: "100vw",
  overflow: "hidden",
  [theme.breakpoints.down("md")]: {
    height: "fit-content",
    maxHeight: "fit-content",
    "& .page-title": {
      fontSize: "2em",
    },
  },
}));

export const ContactScreen = styled("div")(({theme,dark}) => ({
  width: "100vw",
  height: "calc(100vh - 50px)",
  padding: "20px 40px",
  display: "flex",
  flexDirection: "column",

  "& .page-title": {
    fontSize: "3em",
    color: dark?"#FF3B81":"#3957D2",
    fontWeight: 700,
    margin: "20px 0 0 0 ",
  },
  [theme.breakpoints.down("md")]: {
    height: "fit-content",
    maxHeight: "fit-content",
    "& .page-title": {
      fontSize: "2em",
    },
  },
}));

export const ContactMainContainer = styled("div")(() => ({
  width: "100%",
  flex: 1,
  display: "flex",
  flexDirection: "row",
  flexWrap:'wrap'
}));

export const ContactLottieContainer = styled("div")(({theme}) => ({
  width: "40%",
  height: "100%",
  display: "grid",
  placeItems: "center",
  [theme.breakpoints.down('md')]:{
    width:"100%",
    height:"50%"
  }

}));

export const ContactLottie = styled("div")(({theme})=>({
  width:600,
  height:600,
  [theme.breakpoints.down('lg')]:{
    width:500,
    height:500
  },
  [theme.breakpoints.down('md')]:{
    width:400,
    height:400
  }
}))

export const ContactDataContainer = styled("div")(({theme}) => ({
  width: "60%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  //   backgroundColor:'red'
  "& .react-reveal": {
    width: "100%",
    height: "100%",
    zIndex:999,
  },
  [theme.breakpoints.down('md')]:{
    width:"100%",
    height:"50%"
  }
}));

export const ContactCard = styled(Card)(({theme,dark}) => ({
  width: "60%",
  height: "fit-content",
  borderRadius: 10,
  boxShadow: "0px 8px 20px rgba(35, 35, 35, 0.1)",
  backgroundColor: dark?"#22262E": "#fff",
  padding: "30px 30px",
  margin: "10px auto",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",

  "& .contact-header": {
    fontSize: "1.5em",
    fontWeight: 700,
    letterSpacing: "2px",
    wordSpacing: "5px",
    color: dark?"#FF3B81":"#3957D2",
    marginBottom: "20px",
  },
  "& form": {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  "& .MuiTextField-root": {
    margin: "5px auto",
    // borderRadius:20
  },

  "& .MuiOutlinedInput-root": {
    borderRadius: 5,
    "& fieldset": {
      borderColor:dark?"#FF3B81":"#3957D2",
    },
    "&:hover fieldset": {
      borderColor:dark?"#FF3B81":"#3957D2",
    },
    "&.Mui-focused fieldset": {
      borderColor:dark?"#FF3B81":"#3957D2",
    },
  },
  '& label':{
    color:'#FF3B81',
  },
  '& label.Mui-focused': {
    color: '#FF3B81',

  },
  '& .error-message':{
    color:'red',
    width:'100%',
    fontSize:'0.8em', 
    marginBottom:'10px'
  },
  [theme.breakpoints.down('lg')]:{
    width:'70%'
  },
  [theme.breakpoints.down('md')]:{
    width:'60%'
  },
  [theme.breakpoints.down('sm')]:{
    width:'90%'
  }
}));


export const SendButton = styled(Button)(({dark})=>({
  width:'fit-content',
  height: 'fit-content',
  padding:'5px 20px',
  backgroundColor:dark?"#FF3B81":"#3957D2",
  color:'#fff',
  borderRadius:'5px',
  marginTop:'10px',
  '&:hover':{
    backgroundColor:dark?"#FF3B81":"#3957D2",
    color:'#fff',
  }
}))
